
/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Form, Button, Row, Col, Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import Datatable from 'shared/datatable';
import { adminBuyerList,buyersuspendalllist,buyersuspendcount,secret_key } from 'shared/settings/apiconfig';
import Notes from './Notes';
import { connect } from 'react-redux';

// style imports
import './BuyerList.scss';
import axios from 'axios';
import { getSellerHeaders, getSellerUrl, getBuyerUrl, getBuyerHeaders, } from 'shared/http';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to list buyers
 * 
 * @param props
 * 
 * @returns html code to render the buyers list
 * 
**/

export class BuyerList extends Component {

    config;
    buyerAccessToken;
    buyerHeaders;
    initialSearchState;
    filterSearch;
    id;
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.id = '';
        /* initial search state */
        this.initialSearchState = {
            firstname: { field: 'firstname', value: '', op: 'LIKE', join: 'AND' },
            lastname: { field: 'lastname', value: '', op: 'LIKE', join: 'AND' },
            nickname: { field: 'nickname', value: '', op: '=', join: 'AND' },
            email: { field: 'email', value: '', op: 'LIKE', join: 'AND' },
            mobile: { field: 'mobile', value: '', op: 'LIKE', join: 'AND' },
            suspended: { field: 'suspended', value: '', op: '=', join: 'AND' },
            //isDeleted: { field: 'isDeleted', value: 0, op: '=', join: 'AND' },
            //inactive: { field: 'active', value: '', op: '=', join: 'AND' },
            starttime: { field: 'createddate', value: '', op: '>=', join: 'AND' },
            endtime: { field: 'createddate', value: '', op: '<=', join: 'AND' },
        }
        this.state = {
            buyerAccessToken: '',
            buyerHeaders: {},
            search: this.initialSearchState,
            searchData: false,
            tableData: [],
            // notesModal: false,
            issearch: false,
            buyerDetails: {},
            showSuspensionModal: false,
            suspendList: [],
            suspensionlocationlist: [],
            buyerToken: '',
            errorpageredirect: false,
            errorType: ''
        }

        this.config = {
            name: 'buyer',
            url: adminBuyerList,
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: [ 'notes','edit','flag' ], customHeader: <></>, width: '75px',
                    actionEvents: { edit: (row, state) => { row['headers'] = this.buyerHeaders; this.props.history.push({ pathname: `/buyer/edit/${row['id']}`, state: { prevPath: this.props.match.url, tabledata: this.state.tableData.stateData} }) }, 
                    notes: (id) => { this.viewNotes(id)},
                    flag: (row) => { this.suspensionCountList(row) } }
                },
                { name: 'Name', property: 'lastname', sort: false, width: '280px', columnType: 'custom', customColumn: this.customName },
                { name: 'User Name', property: 'nickname', sort: true, width: '130px' },
                { name: 'Email', property: 'email', sort: true, width: '130px' },
                { name: 'Phone', property: 'mobile', sort: false, width: '130px', sortType: 'num' },
                { name: 'Date', property: 'modifieddate', sort: true, sortType: 'num', width: '130px', columnType: 'custom', customColumn: this.customModifiedDate },
                { name: 'Status', property: 'active', sort: false, sortType: 'num', width: '130px', columnType: 'custom', customColumn: this.customStatus },
                // { name: 'Last Purchased', property: 'purchasedate', sort: true, width: '160px', columnType: 'custom', customColumn: this.customDate },
                // {
                //     name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: <></>, width: '100px',
                //     accordion: this.accordionValue
                // }
            ],
            field: [ "id", "firstname", "lastname", "email", "nickname", "mobile", "active", "modifieddate", "profilecompleted", "address1", "address1", "address2", "state", "city", "zipcode", "biddedlocationcount", "bidwoncount", "isDeleted", "suspensioncount" ],
            sort: [{ field: 'nickname', direction: 'asc' }],
            pagination: true,
            adminUrl: {},
            ignoreRowBackground: true
        };
        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                if (temp['field'] === 'modifieddate') {
                    temp['value'] = new Date(temp['value']);
                }
                if (temp['field'] === 'modifieddate' && temp['op'] === '<=') {
                    temp['field'] = 'endtime';
                }
                if (temp['field'] === 'modifieddate' && temp['op'] === '>=') {
                    temp['field'] = 'starttime';
                }
                tempSearch[temp['field']] = temp;
            });

            this.state['search'] = tempSearch;
            this.state['issearch'] = Boolean(search.length);
            this.state['searchData'] = true;
        }
    }

    componentDidMount() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);    
        this.getBuyerToken()
    }
    getBuyerToken() {
        axios.get(getSellerUrl(`${secret_key}`), getSellerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                this.setState({
                    buyerToken: response.data.accessToken,
                }, () => { 
                });
            }
        }).catch(error => {
            if(error.response.status == 401 || error.response.status == 404) {
                this.setState({
                    errorpageredirect: true,
                    errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                })
            }
        });
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }


    customName = (values) => <span>{`${values['lastname']} ${values['firstname']}`}</span>;
    customModifiedDate = (value) => {
        if (value['modifieddate']) {
            return `${moment.utc(value['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    }
    customDate = (value) => {
        if (value['purchasedate']) {
            return `${moment.utc(value['purchasedate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    customStatus = (values) => {
        if (values['suspensioncount'] > 0 && values['active'] == 1) {
            return <span>Suspended/Active</span>
        } else if (values['suspensioncount'] > 0 && values['active'] == 0 && values['isDeleted'] == 1) {
            return <span>Suspended/Deleted</span>
        } else if (values['active'] == 0 && values['isDeleted'] == 1) {
            return <span>Deleted</span>
        } else if (values['profilecompleted'] == 0) {
            return <span>Partial Registered</span>;
        } else if (values['bidwoncount'] > 0) {
            return <span>Buyer</span>;
        } else if (values['biddedlocationcount'] > 0) {
            return <span>Bidder</span>;
        } else if (values['biddedlocationcount'] == 0) {
            return <span>Registered</span>;
        }
    }

    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div style={{ padding: "1% 2%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex" style={{ justifyContent: "space-evenly"}}>
                         <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Address 1</div>
                            <div>{row['address1'] ? row['address1'] : '- - -' }</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Address 2</div>
                                <div>{row['address2'] !=null ? row['address2']: '- - -'}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">City</div>
                            <div>{row['city'] ? row['city'] : '- - -'}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">State</div>
                            <div>{row['state'] ? row['state'] : '- - -'}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Zip Code</div>
                            <div>{row['zipcode'] ? row['zipcode'] : '- - -'}</div>
                        </div>  
                    </div>
                    : ''}
            </div>
        );
    }
    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if (event.target.name === 'inactive' || event.target.name === 'suspended') {
            eventValue = event.target.checked;
        }
        if (event.target.name === 'mobile') {
            if (isNaN(eventValue))
                eventValue = '';
        }

        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: eventValue
                }
            }
        }, () => {
            if (event.target.value === '')
                this.checkSearch();
        });
    }

    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        let search = {};
        search = {
            firstname: { ...this.state.search.firstname, value: this.state.search.firstname.value ? this.state.search.firstname.value + '*' : '' },
            lastname: { ...this.state.search.lastname, value: this.state.search.lastname.value ?  this.state.search.lastname.value + '*' : '' },
            email: { ...this.state.search.email, value: this.state.search.email.value ? '*' + this.state.search.email.value + '*' : '' },
            mobile: { ...this.state.search.mobile, value: this.state.search.mobile.value ? '*' + this.state.search.mobile.value + '*' : '' },
            nickname: { ...this.state.search.nickname, value: this.state.search.nickname.value ? this.state.search.nickname.value  : '' },
            starttime: { ...this.state.search.starttime, value: this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            endtime: { ...this.state.search.endtime, value: this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            suspended: { ...this.state.search.suspended },
            // isDeleted:{...this.state.search.isDeleted, value: 0  },
            // inactive: { ...this.state.search.inactive, value: this.state.search.inactive.value ? 0 : 1 },
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        });
    }

    /* called when note clicked */
    viewNotes = (id) => {
        if (window.location.href.endsWith("/buyer")) {
            const data = this.state.tableData.data.filter(x => x.id === id);
            // let data = buyerMockData.filter(x => x.id === id);
            if (data.length > 0) {
                data[0]['title'] = data[0]['lastname'] + ',' + data[0]['firstname'];
                data[0]['headers'] = this.buyerHeaders;
                this.setState({
                    ...this.state,
                    modal: true,
                    buyerDetails: data[0]
                });
                this.id = id;
            }
        }
    }

    /* called when save or note closed */
    hideNotes = () => {
        this.setState({
            ...this.state,
            modal: false
        })
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter' && !this.isSearchDisabled()) {
            this.enableSearch()
        }
    }

    /* set date for date input change */
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        });
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    suspensionCountList = (row) => {
        axios.get(getBuyerUrl(`${buyersuspendcount}${row.id}`), getBuyerHeaders(this.state.buyerToken)).then(
            response => {
                if (response.data.status === 'success') {
                    this.setState({
                        suspensionlocationlist: response.data.data.suspended_data,
                        unsuspensionlocationlist: response.data.data.unsuspended_data,
                    }, () => {
                        this.suspensionDetails(row.id)
                    })

                }
            }).catch(
                error => {

                }
            );
    }


    suspensionDetails =  (id) => {
        const suspendPostData = {
            'buyerid': id,"locationid":this.state.suspensionlocationlist

        };
        axios.post(getSellerUrl(buyersuspendalllist),{ "data" : suspendPostData }, getSellerHeaders())
            .then(response => {
                this.setState({
                    suspendList: response?.data?.data,
                    showSuspensionModal: true
                })
            })
            .catch(error => {});
    }
    isSearchDisabled = () => {
        const { search, errorMessage } = this.state;
        const requiredFields = ['firstname', 'lastname', 'nickname', 'email', 'mobile'];
      
        // Check if at least one required field has value
        const hasRequiredValue = requiredFields.some(
          field => search[field].value && search[field].value.trim() !== ''
        );
      
      
        // Final disable logic
        return !hasRequiredValue || errorMessage;
      };

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div className="buyer-list">
                <div className="d-flex flex-column justify-content-center align-items-center bg-search" style={{ padding: "1% 3%" }}>
                    <Row className="d-flex flex-row w-100">
                        <Col className="d-flex flex-column text-secondary">
                            <small>First Name</small>
                            <Form.Control onKeyDown={this._handleKeyDown} type="text" name="firstname" value={this.state.search.firstname.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary">
                            <small>Last Name</small>
                            <Form.Control onKeyDown={this._handleKeyDown} type="text" name="lastname" value={this.state.search.lastname.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary">
                            <small>User Name</small>
                            <Form.Control onKeyDown={this._handleKeyDown} type="text" name="nickname" value={this.state.search.nickname.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary">
                            <small>Email Address</small>
                            <Form.Control onKeyDown={this._handleKeyDown} type="text" name="email" value={this.state.search.email.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary">
                            <small>Phone Number</small>
                            <Form.Control onKeyDown={this._handleKeyDown} type="text" name="mobile" value={this.state.search.mobile.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                    </Row>
                    {/* <Row className="d-flex flex-row w-100">
                        <Col className="d-flex flex-column text-secondary">
                            <small>Created Date From</small>
                            <div>
                                <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                    <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                    <i style={{ position: "absolute", top: "48%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                </label>
                            </div>
                        </Col>
                        <Col className="d-flex flex-column text-secondary">
                            <small>Created Date To</small>
                            <div>
                                <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                    <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                    <i style={{ position: "absolute", top: "48%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                </label>
                            </div>
                        </Col>
                        <Col className="offset-5"></Col>

                    </Row>  */}
                    {/* <Row className="d-flex flex-row p-2 w-100">
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Item SKU</small>
                            <Form.Control type="text" name="itemSKU" value={this.state.search.itemSKU.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Item Title</small>
                            <Form.Control type="text" name="itemtitle" value={this.state.search.itemtitle.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Location</small>
                            <Form.Control type="text" name="location" value={this.state.search.location.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Sale</small>
                            <Form.Control type="text" name="saletitle" value={this.state.search.saletitle.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Category</small>
                            <Form.Control type="text" name="category" value={this.state.search.category.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                    </Row> */}
                    <Row className="d-flex w-100">
                        <Col md={6}></Col>
                        <Col md={6}>
                            <div className="buttonClass">
                                <Button variant="clear-button" style={{ boxShadow: "none" }} onClick={() => this.resetState()}>Clear All</Button>
                                <Button style={{ marginLeft: "2%" }} disabled={this.isSearchDisabled()  || this.state.errorMessage} variant="seller-search" onClick={() => this.enableSearch()}>Search</Button>
                            </div>
                        </Col>
                    </Row>
                </div>
                {this.state.modal ?
                    <Notes modal={this.state.modal} id={this.id} name='buyer' data={this.props} hideNotes={this.hideNotes} /> : ''
                }
                <div className="buyer-table">
                    {/* need to add props, as it provides the previous state of datatable */}
                    <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData} />
                </div>

                <Modal centered show={this.state.showSuspensionModal} className="suspendModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Row xs={1} sm={1} className="w-100">
                            <Col md={3}><h5>Location</h5></Col>
                            <Col md={2}><h5>Suspension Type</h5></Col>
                            <Col md={2}><h5>Suspension Notes</h5></Col>
                            <Col md={2}><h5>Suspension Date</h5></Col>
                            <Col md={2}><h5>Suspended By</h5></Col>
                        </Row>
                        <Button type="button" onClick={() => {this.setState({ showSuspensionModal: false })}} className="close-suspension" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button> 
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.suspendList.map(response =>
                                <div className="border-bottom">
                                    <Row xs={1} sm={1} className="w-100 p-3">
                                        <Col md={3} style={{ wordBreak: "break-word" }}><b>{response['locationtitle'] ?  response['locationtitle']  : '- - -'}</b></Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['suspensiontype'] ? response['suspensiontype'] : '- - -'}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['reason'] ? response['reason'] : '- - -'}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{moment.utc(response['effectivedate']).local().format('MM-DD-YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</Col>
                                        <Col md={2} style={{ wordBreak: "break-word" }}>{response['suspendedby'] ? response['suspendedby'] : '- - -'}</Col>
                                    </Row>
                                </div>
                            )
                        }
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default connect(state => state)(BuyerList);
